import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
//components
import Modal from "../../../../components/modal/Modal";
import Simulator from "../../../SalesManagement/Enterprise/Simulator/Simulator";
import EnterpriseMap from "../../../SalesManagement/Enterprise/Map/Map";
//services
import { patchLeadStatus } from "../../../../services/Crm/Funnel/patchLeadStatus";
import { queryClient } from "../../../../utils/queryClient";

export const ModalBooking = ({
  visible,
  setVisible,
  baseData,
  refetchLeads,
  movePayload,
  onHide,
}) => {
  const [hasReserved, setHasReserved] = useState(false);

  useEffect(() => {
    // console.log(hasReserved);
    const fetchData = async () => {
      if (hasReserved === true) {
        // console.log("Reserva realizada com sucesso");
        setVisible(false);
        const notificationMove = toast.loading("Movendo lead...");

        
        try {
          await patchLeadStatus(movePayload);
          refetchLeads();
          toast.update(notificationMove, {
            render: "Lead movido com sucesso!",
            type: toast.TYPE.SUCCESS,
            isLoading: false,
            autoClose: 2000,
          });
        } catch (error) {
          // setFunnel(previousFunnel);
          toast.update(notificationMove, {
            render: "Erro ao mover lead!",
            type: toast.TYPE.ERROR,
            isLoading: false,
            autoClose: 2000,
          });
        }
      }
    };
    fetchData();
  }, [hasReserved]);

  // console.log("Base Data", baseData);
  return (
    <Modal dynamicTitle="Realizar Reserva" visible={visible} onHide={onHide}>
      <Simulator
        crmData={{
          fromCard: true,
          onHide: onHide,
          empId: baseData?.enterprise_id,
          broker_id: baseData?.broker_id,
          user_id: baseData?.user_id,
          team_id: baseData?.team_id,
          setHasReserved: setHasReserved,
        }}
      />
    </Modal>
  );
};
